import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import Select from 'react-select'
import {getDedicatedNumber} from '../../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import * as CompanyEmailValidator from 'company-email-validator'
import {createEmailToSms, updateEmailToSms} from '../EmailToSmsSlice/EmailToSmsSlice'
import {getCustomNunberList} from '../../accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {getBusinessName} from '../../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {KTSVG} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field, Form, Formik} from 'formik'
import {emailToSmsSchema} from '../../../../Utils/_helpers/ValidationSchema'
import {GLOBAL_SETTINGS_TYPE, REGION} from '../../../../Utils/Constant/ConstantForWebsite'
import {getDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const Emailtosms = ({show, handleClose, data}: any) => {
  const dispatch = useDispatch()
  const virtualNumber = useSelector(getDedicatedNumber)
  const CustomNumberList = useSelector(getCustomNunberList)
  const bussinessName = useSelector(getBusinessName)
  const userRegion = useSelector(getDefaultRegion)

  const [error, setError] = useState<any>({
    error: '',
    sender: '',
    wildCardDomain: '',
  })
  const [emailtosmsData, setEmailtosmsData] = useState({
    email: '',
    sender: '#SharedNum#',
    wildCardDomain: '',
  })

  const dedicatedOptionSMS: any = virtualNumber
    ? virtualNumber
        ?.filter((key: any) => key?.type == 'SMS')
        ?.map((key: any) => ({
          value: key?.audNumber,
          label: key?.audNumber,
          disabled: key?.status === 'inactive',
        }))
    : []

  const dedicatedOptionMMS: any = virtualNumber
    ? virtualNumber
        ?.filter((key: any) => key?.type == 'MMS')
        ?.map((key: any) => ({
          value: key?.audNumber,
          label: key?.audNumber,
          disabled: key?.status === 'inactive',
        }))
    : []
  const businessNameOption: any = bussinessName
    ? bussinessName?.map((key: any) => ({
        value: key?.businessname,
        label: key?.businessname,
      }))
    : []

  const customNumberOption: any = CustomNumberList
    ? CustomNumberList?.map((key: any) => ({
        value: key?.number,
        label: key?.number,
      }))
    : []

  let optoutList: any = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
      GLOBAL_SETTINGS_TYPE.EMAIL_TO_SMS_REPLY_STOP_OUTPUT
    )

    return isDisableReplyByGlobalOption ? list : []
  })

  const CustomOptOutList =
    optoutList?.length > 0
      ? optoutList?.map((key: any) => {
          return {
            value: `${key?._id}`,
            label: `${key?.title}`,
          }
        })
      : []

  const UpdateData = ({setFieldValue, data, show}: any) => {
    useEffect(() => {
      if (data?._id) {
        setFieldValue('email', data?.email?.join())
        setFieldValue('sender', data?.sender)
        setFieldValue('wildCardDomain', data?.wildCardDomain)
        setFieldValue('setAsForwarded', data?.setAsForwarded || false)
      } else {
        setFieldValue('email', '')

        if ([REGION.AU, REGION.US].includes(userRegion)) {
          setFieldValue('sender', '#SharedNum#')
        } else {
          setFieldValue('sender', '')
        }

        setFieldValue('wildCardDomain', '')
        setFieldValue('setAsForwarded', false)
      }
    }, [show, userRegion])

    return <></>
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-487px'
        className='vh-100'
        show={show}
        onHide={() => {
          handleClose()
          setError({
            error: '',
            sender: '',
            wildCardDomain: '',
          })
        }}
      >
        <div className='modal-header'>
          <h1>{`${data?._id ? 'Edit' : 'Add'} new whitelisted address`}</h1>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='w-100 modal-body p-10'>
          <Formik
            initialValues={{
              email: '',
              sender: [REGION.AU, REGION.US].includes(userRegion) ? '#SharedNum#' : '',
              wildCardDomain: '',
              setAsForwarded: false,
              optout:
                [REGION.AU, REGION.US].includes(userRegion) || data?._id
                  ? {value: 'ReplyStop', label: "Reply 'STOP' to opt-out"}
                  : {},
            }}
            validationSchema={emailToSmsSchema}
            onSubmit={(val: any, {setSubmitting}) => {
              let finalData: any = {
                email: val?.email?.split(','),
                sender: val?.sender,
                wildCardDomain: val?.wildCardDomain,
                setAsForwarded: val?.setAsForwarded || false,
                replyStopToOptOut: false,
                optout: false,
                region: userRegion,
              }

              if (val.optout.value === 'ReplyStop') {
                finalData.replyStopToOptOut = true
              } else {
                finalData.replyStopToOptOut = false
                finalData.optout = true
                finalData.optoutId = val.optout.value
                finalData.optoutLabel = val.optout.label
              }

              if (data?._id) {
                dispatch(updateEmailToSms({finalData, id: data?._id}))
                handleClose()
              } else {
                let payload: any = {
                  replyStopToOptOut: false,
                  optout: false,
                  region: userRegion,
                  setAsForwarded: val?.setAsForwarded || false,
                }

                if (val.optout.value === 'ReplyStop') {
                  payload.replyStopToOptOut = true
                  payload.optout = false
                  payload.optoutId = null
                } else {
                  payload.replyStopToOptOut = false
                  payload.optout = true
                  payload.optoutId = val.optout.value
                }

                if (val?.email !== '') {
                  val?.wildCardDomain !== ''
                    ? dispatch(
                        createEmailToSms({
                          email: val?.email?.split(','),
                          sender: val?.sender,
                          wildCardDomain: val?.wildCardDomain,
                          ...payload,
                        })
                      )
                    : dispatch(
                        createEmailToSms({
                          email: val?.email?.split(','),
                          sender: val?.sender,
                          ...payload,
                        })
                      )
                } else {
                  dispatch(
                    createEmailToSms({
                      wildCardDomain: val?.wildCardDomain,
                      sender: val?.sender,
                      ...payload,
                    })
                  )
                }

                handleClose()
              }
            }}
          >
            {({isSubmitting, errors, values, setFieldValue, handleChange}: any) => (
              <Form>
                <div>
                  <label className=' col-form-label fw-bold fs-6'>
                    Sender ID
                    <button
                      className='bg-transparent'
                      type='button'
                      data-bs-toggle='tooltip'
                      title='This is what your recipients will see as their sender'
                    >
                      <i className='bi bi-info-circle-fill'></i>
                    </button>
                  </label>

                  <UpdateData setFieldValue={setFieldValue} data={data} show={show} />

                  <Select
                    value={{value: values?.sender, label: values?.sender}}
                    onChange={(e: any) => setFieldValue('sender', e.value)}
                    name='selector'
                    className='form-select bg-light-primary border-0 mb-0'
                    options={[
                      ...([REGION.AU, REGION.US].includes(userRegion)
                        ? [
                            {
                              label: 'Shared Number',
                              options: [{value: '#SharedNum#', label: '#SharedNum#'}],
                            },
                          ]
                        : []),
                      {
                        label: 'SMS dedicated number',
                        options: dedicatedOptionSMS,
                      },
                      {
                        label: 'MMS dedicated number',
                        options: dedicatedOptionMMS,
                      },
                      {
                        label: 'Custom number',
                        options: customNumberOption,
                      },
                      {
                        label: 'Business name',
                        options: businessNameOption,
                      },
                    ]}
                    isOptionDisabled={(option: any, value: any) =>
                      option?.disabled ? option?.disabled : false
                    }
                  />

                  <p className='text-muted mt-2'>
                    Don't have a dedicated number or business name? Get one <a href='#'> here</a>
                  </p>

                  <label className=' col-form-label fw-bold fs-6'>
                    Allowed email addresses
                    <button
                      className='bg-transparent'
                      type='button'
                      data-bs-toggle='tooltip'
                      title='Allow only trusted email accounts to send messages'
                    >
                      <i className='bi bi-info-circle-fill'></i>
                    </button>
                  </label>
                  <textarea
                    value={values?.email}
                    className='form-control form-control-lg form-control-solid mb-3'
                    onChange={handleChange}
                    rows={5}
                    name='email'
                    placeholder='Email,email,email,email,email,email'
                  ></textarea>
                  <ErrorMessage className='text-danger' name='email' component='div' />

                  <div className='form-check form-check-custom form-check-solid mb-3'>
                    <Field
                      type='checkbox'
                      name='setAsForwarded'
                      id='setAsForwarded'
                      className='form-check-input'
                    />
                    <label className='form-check-label fw-bold fs-6' htmlFor='setAsForwarded'>
                      Set as forwarded inbound message
                    </label>
                  </div>

                  <label className=' col-form-label fw-bold fs-6'>
                    Wildcard domain
                    <button
                      className='bg-transparent'
                      type='button'
                      data-bs-toggle='tooltip'
                      title='A wildcard will whitelist all email addresses on your domain'
                    >
                      <i className='bi bi-info-circle-fill'></i>
                    </button>
                  </label>
                  <input
                    value={values?.wildCardDomain}
                    onChange={handleChange}
                    name='wildCardDomain'
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3'
                    placeholder='yourdomain'
                  />
                  <ErrorMessage className='text-danger' name='wildCardDomain' component='div' />

                  {CustomOptOutList.length > 0 && (
                    <>
                      <label className=' col-form-label fw-bold fs-6'>Opt Out</label>
                      <div className='' style={{width: '100%'}}>
                        <Select
                          isSearchable={false}
                          menuPlacement='bottom'
                          onChange={(e: any) => setFieldValue('optout', e)}
                          value={values.optout}
                          options={[
                            ...([REGION.AU, REGION.US].includes(userRegion) || data?._id
                              ? [{value: 'ReplyStop', label: "Reply 'STOP' to opt-out"}]
                              : []),
                            ...CustomOptOutList,
                          ]}
                          name='optout'
                          className='form-select form-select-solid'
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className='d-flex justify-content-end mt-10 border-top pt-6'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      onClick={() => {
                        handleClose()
                        setError({
                          error: '',
                          sender: '',
                          wildCardDomain: '',
                        })
                      }}
                      type='button'
                      className='btn btn-md gray_bg_purple me-2'
                    >
                      Cancel
                    </button>
                  </div>
                  <button
                    disabled={values?.sender == '' || !!errors?.wildCardDomain || !!errors?.email}
                    type='submit'
                    className='btn btn-md btn-primary btn-blue fw-500   w-100px p-3 border border-primary'
                  >
                    <span className='indicator-label'>{data?._id ? 'Edit' : 'Add'}</span>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default Emailtosms
